// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__hnhXP","icon":"Alert_icon__7Sq7o"};